import { render } from "./Three.vue?vue&type=template&id=995bcc0a"
import script from "./Three.vue?vue&type=script&lang=js"
export * from "./Three.vue?vue&type=script&lang=js"

import "./Three.vue?vue&type=style&index=0&id=995bcc0a&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__